import { useContext } from 'react';
import { HelpModeContext, type HelpModeValue } from './help-mode';

/**
 * Help mode, with a working answer when no provider is mounted.
 *
 * The context-less fallback is deliberate and matches `useTranslate`:
 * a screen rendered in a test, or in some future shell that has not
 * mounted the provider, must render normally with the help simply
 * absent. A hook that threw here would make every note a place the app
 * can crash, which is a poor trade for a feature whose entire job is
 * to be reassuring.
 */
export function useHelpMode(): HelpModeValue {
  const ctx = useContext(HelpModeContext);
  if (!ctx) {
    return { enabled: false, seen: true, setEnabled: () => {}, toggle: () => {} };
  }
  return ctx;
}
